    
var video_slide = new Swiper ('.main-video', {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
  
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
     autoplay:{
      delay: 5000,
      disableOnInteraction: false  
     }
  });